import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HEADER_OFFSET = 80;

/** Fait défiler jusqu'à l'ancre de l'URL (ex. `/#faq`) après le rendu de la page. */
export const useScrollToHash = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const timer = setTimeout(() => {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        const top = element.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [hash]);
};
